/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * ActionBarImage.tsx - Logo to display on right side of nav bar.
 */

import { Image } from 'react-native';


const ActionBarImage = ({height}: {height: number}) => {
  return (
    <Image
      source={require('./assets/images/WRMLogoTransparent.png')}
      style={{
        height: height,
        width: height,
        marginRight: height/4,
        resizeMode: 'contain'
      }}
    />
  );
};

export default ActionBarImage;
